let ns_session_var = window.ns_session_var;
let tax = window.tax;
let currency = window.currency;
let culture = window.culture;
let country = window.country;


function intToBool(value) {
    return Boolean(Number(value));
}

function getCartUrl(netsuite_url, netsuite_id, components = null, is_standalone = false) {
    let locId = 25; // Default is AU
    var regionId = 7;
    switch(culture.toLowerCase()) {
        case 'en-nz':
            locId = 16;
            regionId = 5;
            break;
        case 'en-us':
        case 'es-us':
            locId = 4;
            regionId = 4;
            break;
        default:
            locId = 25;
            regionId = 7;
    }
      
     if (country == 'NZ') { country = 'AU';}
     if (country == 'nz') { country = 'au';}

     let t = parseInt(Date.now() / 1000);
     if(is_standalone) {
        var ids = components;
        return netsuite_url + "api/items?&include=facets&pricelevel=5&c=" + ns_session_var + "&fieldset=details&n=2&region=" + regionId + "&currency=" + currency + "&id=" + ids.join(',') + `&t=` + t;
     }
     else if (!components) {
        return netsuite_url + "api/items?&include=facets&pricelevel=5&c=" + ns_session_var + "&fieldset=details&n=2&region=" + regionId + "&currency=" + currency + "&id=" + netsuite_id + `&t=` + t;
      } else {
        var ids = components.map((item, index) => {
          return item.product.netSuiteId;
        });
        ids.push(netsuite_id);
        return netsuite_url + "api/items?&include=facets&pricelevel=5&c=" + ns_session_var + "&fieldset=details&n=2&region=" + regionId + "&currency=" + currency + "&id=" + ids.join(',') + `&t=` + t;
      }

}

export { intToBool, getCartUrl };